import { render, staticRenderFns } from "./BtnDescontoItemRequisicao.vue?vue&type=template&id=50596991&"
import script from "./BtnDescontoItemRequisicao.vue?vue&type=script&lang=js&"
export * from "./BtnDescontoItemRequisicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports